module.exports = __webpack_public_path__ + "img/exam_jan_2025_5e82zxa8.1499c16e.jpg";